<template>
    <div class="account-container-wrapper">
        <div
            class="d-flex align-items-center"
            style="gap: 10px;"
        >
            <div
                class="rounded-lg bg-success text-white"
                style="font-size: 16px; padding: 4px 10px;"
            >
                <i class="fas fa-user"></i>
            </div>
            <div>
                <p
                    class="mb-0"
                    style="font-weight: bold;"
                >{{ $store.state.authUser.name }}</p>
                <p
                    class="mb-0"
                    style="font-weight: bold;"
                >{{ $store.state.authUser.phone ?? '-' }}</p>
            </div>
        </div>
        <div class="bg-success d-flex justify-content-around align-items-stretch text-white rounded-lg mt-2 p-4">
            <div class="text-center flex-fill d-flex flex-column justify-content-center">
                <p class="mb-1 font-weight-bold">
                    {{ Number($store.state.totalWithdraw ?? 0).toLocaleString() }}
                    {{ $store.state.language === 'en' ? 'MMK' : 'ကျပ်' }}
                </p>
                <p class="mb-0">
                    {{ $store.state.language === "en" ? "Withdraw" : "ငွေထုတ်" }}
                </p>
            </div>

            <!-- Separator -->
            <div class="vertical-separator"></div>

            <div class="text-center flex-fill d-flex flex-column justify-content-center">
                <p class="mb-1 font-weight-bold">
                    {{ Number($store.state.amount ?? 0).toLocaleString() }}
                    {{ $store.state.language === 'en' ? 'MMK' : 'ကျပ်' }}
                </p>
                <p class="mb-0">
                    {{ $store.state.language === "en" ? "Balance" : "လက်ကျန်ငွေ" }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProfileCard",
};
</script>

<style scoped>
.account-container-wrapper {
    font-size: 16px;
    width: auto;
    height: auto;
    border-radius: 10px;
    padding: 10px;
    color: #101010;
    background: #FCFCF9;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.vertical-separator {
    width: 1px;
    background-color: rgba(255, 255, 255, 0.5);
    align-self: stretch;
}
</style>
